export const REPORTS_SETTING_KEY = 'reports-settings'
export const PERIOD_SET_ID_PARAM = 'report_period_set_id'
export const SELECTED_DIMENSIONS_PARAM = 'selected_dimensions'
export const RENDER_PARAM = 'render'

// MessageBus channel a deferred report render publishes its completion on.
// Must match Report::AsyncRenderCoordinator::CHANNEL on the backend.
export const ASYNC_RENDER_CHANNEL = '/reports/render'

// The pinned-cards island has just rendered fetched cards. The reports--index
// search listens so an already-typed filter applies to them.
export const PINNED_CARDS_RENDERED = 'reports:pinned-cards-rendered'

// Pinned graph chart heights — used by the drawer's PinnedGraphCard and the
// reports-index PinnedReportCard. Fullscreen value is only relevant to the
// drawer (the index card is always compact).
export const PINNED_CHART_HEIGHT_DEFAULT = '260px'
export const PINNED_CHART_HEIGHT_FULLSCREEN = '520px'

export const REPORT_GRAPHS_DRAWER_ID = 'report-graphs-drawer'
// The flex row in reports/show.html.slim that holds the sidebar, the table and
// the Edit columns drawer. The sidebar's width is bounded by it.
export const REPORT_ROW_SELECTOR = '.report-column-editor-row'

// The sidebar opens at the Edit columns drawer width until the user drags it,
// and a drag never takes it under the width the metric pills need.
export const REPORT_GRAPHS_DRAWER_DEFAULT_WIDTH_PX = 460
export const REPORT_GRAPHS_DRAWER_MIN_WIDTH_PX = 340
// A dragged width is stored per user as a percentage of the report row. Bounds
// must match UserPreferencesContract::REPORT_GRAPHS_DRAWER_WIDTH_RANGE.
export const REPORT_GRAPHS_DRAWER_MIN_WIDTH_PCT = 15
export const REPORT_GRAPHS_DRAWER_MAX_WIDTH_PCT = 60
